import { Component, EventEmitter, Output, Input, OnInit } from '@angular/core';
import { FormBuilder } from '@angular/forms';
import { Router } from '@angular/router';
import 'rxjs/add/operator/filter';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/mergeMap';
import { AlertService } from 'ngx-alerts';
import { NgxSpinnerService } from 'ngx-spinner';
import { Client } from '../services/client';

@Component({
	selector: 'app-date-picker',
	templateUrl: './date-picker.component.html',
	styleUrls: ['./date-picker.component.scss']
})
export class DatePickerComponent implements OnInit {
	monthSelect: any = -1;
	daySelect: any = -1;
	yearSelect: any = -1;
	previousDay;

	@Output() selectedDateChange = new EventEmitter();
	@Input() selectedDate = undefined;

	allDays = [];
	// How many years back should we go
	yearsBefore = 120;
	allYears = [];

	constructor(
		public router: Router,
		public client: Client,
		private spinner: NgxSpinnerService,
		private alertService: AlertService
	) {
		const todayDate = new Date();
		// populate the days and years dynamically
		// (the months are always the same, therefore hardcoded)
		// this.populateDays(this.monthSelect, this.yearSelect);
		this.populateDays(todayDate.getMonth());
		this.populateYears();
	}

	ngOnInit() {
		if (!!this.selectedDate) {
			this.yearSelect = this.selectedDate.getFullYear();
			this.monthSelect = this.selectedDate.getMonth();
			this.daySelect = this.selectedDate.getDay();
		}
	}

	selectedDateChanged() {
		if (this.yearSelect != -1 && this.monthSelect != -1 && this.daySelect != -1) {
			this.selectedDateChange.emit(`${this.yearSelect}-${parseInt(this.monthSelect, 10) + 1}-${this.daySelect}`);
		} else {
			this.selectedDateChange.emit(
				this.yearSelect != -1 || this.monthSelect != -1 || this.daySelect != -1 ? null : undefined
			);
		}
	}

	populateDays(month) {
		this.allDays = [];
		// Create variable to hold new number of days to inject
		let dayNum;

		// 31 or 30 days?
		if (month === 0 || month === 2 || month === 4 || month === 6 || month === 7 || month === 9 || month === 11) {
			dayNum = 31;
		} else if (month === 4 || month === 5 || month === 8 || month === 10) {
			dayNum = 30;
		} else {
			// If month is February, calculate whether it is a leap year or not
			// What if year is not selected?
			if (!!this.yearSelect) {
				(this.yearSelect - 2016) % 4 === 0 ? dayNum = 29 : dayNum = 28;
			} else {
				dayNum = 28;
			}
		}

		// inject the right number of new <option> elements into the day <select>
		for (let i = 1; i <= dayNum; i++) {
			this.allDays.push(i);
		}

		// if previous day has already been set, set daySelect's value
		// to that day, to avoid the day jumping back to 1 when you
		// change the year
		if (this.previousDay) {
			this.daySelect = this.previousDay;

			// If the previous day was set to a high number, say 31, and then
			// you chose a month with less total days in it (e.g. February),
			// this part of the code ensures that the highest day available
			// is selected, rather than showing a blank daySelect
			if (this.daySelect === '') {
				this.daySelect = this.previousDay - 1;
			}

			if (this.daySelect === '') {
				this.daySelect = this.previousDay - 2;
			}

			if (this.daySelect === '') {
				this.daySelect = this.previousDay - 3;
			}
		}
	}

	populateYears() {
		// get this year as a number
		const todayDate = new Date();
		const currentYear = todayDate.getFullYear();

		// Make this year, and the 120 years before it available in the year <select>
		for (let i = 0; i <= this.yearsBefore; i++) {
			this.allYears.push(currentYear - i);
		}
	}

}

